import { gql } from '@generated/gql';

export const sendFocus = gql(`
  mutation AppointmentInteractionFocus($id: ID!, $element: ID!) {
    appointmentInteractionFocus(id: $id, element: $element)
  }
`);

export const sendClick = gql(`
  mutation AppointmentInteractionClick($id: ID!, $element: ID!) {
    appointmentInteractionClick(id: $id, element: $element)
  }
`);

export const sendScroll =
  gql(`mutation AppointmentInteractionScroll($id: ID!, $value: String!) {
  appointmentInteractionScrolling(id: $id, value: $value)
  }
  `);
export const interactionEvent = gql(`
  subscription AppointmentInteractions($id: ID!) {
    appointmentInteractions(id: $id) {
      ... on AppointmentInteractionEventFocus {
          element
      }
      ... on AppointmentInteractionEventEntry {
          element
          value
      }
      ... on AppointmentInteractionEventClick {
          element
      }
      ... on AppointmentInteractionEventDialog {
          id
          open
          isLoading
          variant
      }
      ... on AppointmentInteractionEventLoading {
          isLoading
          request
      }
      ... on AppointmentInteractionEventScrolling {
          scrollingValue: value
      }
    }
  }
`);
